import { render } from "./DetalleMensajesView.vue?vue&type=template&id=7190be26&ts=true"
import script from "./DetalleMensajesView.vue?vue&type=script&lang=ts"
export * from "./DetalleMensajesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__